import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import CurrencyTicker from './components/CurrencyTicker';
import Header from './components/Header';
import Footer from './components/Footer';
import Index from './pages/Index';
import About from './pages/About';
import Investments from './pages/Investments';
import HowItWorks from './pages/HowItWorks';
import WhyAltax from './pages/WhyAltax';
import Education from './pages/Education';
import AlternativeInvestmentsGuide from './pages/education/AlternativeInvestmentsGuide';
import HelpCenter from './pages/HelpCenter';
import Careers from './pages/Careers';
import Press from './pages/Press';
import FscaCompliance from './pages/FscaCompliance';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import InvestmentDetail from './pages/InvestmentDetail';
import NotFound from './pages/NotFound';

// A helper component to scroll to the top of the page on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white text-gray-800 font-sans">
      <div className="sticky top-0 z-50">
        <CurrencyTicker />
        <Header />
      </div>
      <ScrollToTop />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/investments" element={<Investments />} />
          <Route path="/investments/:id" element={<InvestmentDetail />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/why-altax" element={<WhyAltax />} />
          <Route path="/education" element={<Education />} />
          <Route path="/education/alternative-investments" element={<AlternativeInvestmentsGuide />} />
          <Route path="/help-center" element={<HelpCenter />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/press" element={<Press />} />
          <Route path="/fsca-compliance" element={<FscaCompliance />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
